<app-page-header [heading]="'Stock Report'" [icon]="'fa-houzz'" style="height:100px;"></app-page-header>
<div *ngIf="user_rights.ADD == '1'" class="page-panel">
  <div class="row">
    <div class="col-5">
      <div class="input-group ">
        <input [(ngModel)]="search_by_date" class="form-control" id="typeahead-http" name="search_by_date"
               placeholder=""
               style="height:31px" type="date">&nbsp;&nbsp;&nbsp;
        <button (click)="listStockReport();" class="btn btn-info btn-sm ng-star-inserted" type="button">&nbsp;Search&nbsp;</button>
      </div>
    </div>
    <div class="col-lg-3"></div>
    <div class="col-lg-4">
      <div class="input-group ">
        <input [(ngModel)]="term" class="form-control" id="typeahead-http" name="search_text" placeholder=""
               style="height:31px" type="text">
        <div class="input-group-append">
                        <span class="input-group-text" style="height:31px;padding:7px">
                            <i class="fa fa-search"></i>
                        </span>
        </div>
      </div>
    </div>
    <div class="form-group col-lg-12 text-right">
      <label></label><br>
      <button (click)="ExportToExcel()" *ngIf="(stock_data | json) != '[]'" class="btn btn-info btn-sm"
              title="Export as XLSX">Export to XLSX&nbsp;<i class="fa fa-file-excel-o"></i></button>&nbsp;
      <app-report-pdf *ngIf="(stock_data | json) != '[]'" targetId="printReport" fileName="Stock_Report.pdf" titleName="STOCK REPORT"></app-report-pdf>
    </div>
    <div class="col-12" id="printReport">
      <table #table class="table tbl table-hover table-bordered" style="background-color: #f3f8fd">
        <thead>
        <tr class="text-center">
          <th width="5%">Sl</th>
          <th>Item</th>
          <th width="8%">Purchased</th>
          <th width="8%">Purchase Return</th>
          <th width="8%">Sales</th>
          <th width="8%">Sales Return</th>
          <th width="8%">Damaged</th>
          <th width="8%">Available</th>
        </tr>
        <tr *ngIf="(stock_data | json) == '[]'">
          <td class="text-center" colspan="7">No data to list</td>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let stock of stock_data| filter:term;let i=index">
          <td class="text-center">{{ i + 1 }}</td>
          <td> {{ stock.TRADE_NAME }}</td>
          <ng-container *ngIf="stock.QUANTITY  != 0">
            <td (click)="opens(purchase);purchaseItemDetails(stock);" class="text-center"
                style="cursor: pointer">{{ stock.QUANTITY }}
            </td>
          </ng-container>
          <ng-container *ngIf="stock.QUANTITY == 0">
            <td class="text-center">{{ stock.QUANTITY }}</td>
          </ng-container>
          <ng-container *ngIf="stock.RETURN_QUANTITY  != 0">
            <td (click)="open(purchase_return);purchaseReturnItemDetails(stock)" class="text-center"
                style="cursor: pointer">{{ stock.RETURN_QUANTITY }}
            </td>
          </ng-container>
          <ng-container *ngIf="stock.RETURN_QUANTITY == 0">
            <td class="text-center">{{ stock.RETURN_QUANTITY }}</td>
          </ng-container>
          <ng-container *ngIf="stock.SALE_QUANTITY  != 0">
            <td (click)="opens(sales);salesItemDetails(stock)" class="text-center"
                style="cursor: pointer">{{ stock.SALE_QUANTITY }}
            </td>
          </ng-container>
          <ng-container *ngIf="stock.SALE_QUANTITY == 0">
            <td class="text-center">{{ stock.SALE_QUANTITY }}</td>
          </ng-container>
          <ng-container *ngIf="stock.SALE_RETURN_QUANTITY  != 0">
            <td (click)="open(sales_return);salesReturnItemDetails(stock)" class="text-center"
                style="cursor: pointer">{{ stock.SALE_RETURN_QUANTITY }}
            </td>
          </ng-container>
          <ng-container *ngIf="stock.SALE_RETURN_QUANTITY == 0">
            <td class="text-center">{{ stock.SALE_RETURN_QUANTITY }}</td>
          </ng-container>
          <ng-container *ngIf="stock.DAMAGE_QUANTITY  != 0">
            <td (click)="open(damaged);DamagedItemDetails(stock)" class="text-center"
                style="cursor: pointer">{{ stock.DAMAGE_QUANTITY }}
            </td>
          </ng-container>
          <ng-container *ngIf="stock.DAMAGE_QUANTITY == 0">
            <td class="text-center">{{ stock.DAMAGE_QUANTITY }}</td>
          </ng-container>
          <td (click)="stock.AVAILABLE != 0 && open(warehuse);stock.AVAILABLE != 0 && StockItemDetails(stock)"
              class="text-center"
              style="cursor: pointer">{{ stock.AVAILABLE }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

  <ng-template #purchase let-modal>
    <div class="modal-header">
      <div class="pull-right">
        <h5 class="modal-title" id="modal-basic-title">
          {{ medicine }}
        </h5>
      </div>
      <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="tab-pane active">
        <div class="tab-content">
          <div class="panel-body">
            <table class="table tbl table-hover table-bordered" style="background-color: #f3f8fd">
              <thead>
              <tr class="text-center">
                <th>Sl</th>
                <th>Invoice No</th>
                <th>Supplier</th>
                <th>Invoice Date</th>
                <th>UOM</th>
                <th>Quantity</th>
              </tr>
              </thead>
              <tbody>
              <ng-container *ngIf=" purchase_list.lenght > 0">
                <tr *ngFor="let item of purchase_list ;let i=index">
                  <td class="text-center">{{ 1 + i }}</td>
                  <td (click)="opens(purchasedetails);purached_items(item)" class="text-primary"
                      style="cursor: pointer">{{ item.INVOICE_NUMBER }}
                  </td>
                  <td>{{ item.VENDOR_NAME }}</td>
                  <td>{{ item.INVOICE_DATE }}</td>
                  <td>{{ item.UNIT_DESC }}</td>
                  <td class="text-center">{{ item.QUANTITY }}</td>
                </tr>
              </ng-container>
              </tbody>
              <tfoot>
              <tr>
                <th colspan="7">Total Qunatity</th>
                <th class="text-center">{{ purchase_quantity }}</th>
              </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #purchase_return let-modal>
    <div class="modal-header">
      <div class="pull-right">
        <h5 class="modal-title" id="modal-basic-title">
          {{ medicine }}
        </h5>
      </div>
      <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="tab-pane active">
        <div class="tab-content">
          <div class="panel-body">
            <table class="table tbl table-hover table-bordered" style="background-color: #f3f8fd">
              <thead>
              <tr class="text-center">
                <th>Sl</th>
                <th>Invoiced Qty</th>
                <th>UOM</th>
                <th>Return Quantity</th>
              </tr>
              </thead>
              <tbody>
              <ng-container *ngIf=" purchase_return_list.length > 0">
                <tr *ngFor="let item of purchase_return_list;let i=index">
                  <td class="text-center">{{ 1 + i }}</td>
                  <td class="text-center">{{ item.QUANTITY }}</td>
                  <td class="text-center">{{ item.UNIT_DESC }}</td>
                  <td class="text-center">{{ item.RETURN_QUANTITY }}</td>
                </tr>
              </ng-container>

              </tbody>
              <tfoot>
              <tr>
                <th colspan="4">Total Qunatity</th>
                <th class="text-center">{{ purchase_return_qty }}</th>
              </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #sales let-modal>
    <div class="modal-header">
      <div class="pull-right">
        <h5 class="modal-title" id="modal-basic-title">
          {{ medicine }}
        </h5>
      </div>
      <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="tab-pane active">
        <div class="tab-content">
          <div class="panel-body">
            <table class="table tbl table-bordered table-hover" style="background-color: #f3f8fd">
              <thead>
              <tr class="text-center">
                <th>Sl</th>
                <th>Invoice No</th>
                <th>Customer</th>
                <th>Invoice Date</th>
                <th>Rate</th>
                <th>Price</th>
                <th>Qty</th>
                <th>Total Cost</th>
                <th>Total</th>
                <th>VAT Credit</th>
                <th>Margin</th>
              </tr>
              </thead>
              <tbody>
              <ng-container *ngIf="sales_list.length > 0">
                <tr *ngFor="let item of sales_list;let i=index">
                  <td class="text-center">{{ 1 + i }}</td>
                  <td (click)="opens(saledetails);sale_items(item.SALE_ID)" class="text-center text-primary"
                      style="cursor: pointer">{{ item.INVOICE_NUMBER }}
                  </td>
                  <td>{{ item.CUSTOMER_NAME }}</td>
                  <td class="text-center">{{ item.INVOICE_DATE }}</td>
                  <td class="text-right">{{ item.UNIT_PRICE | number : '1.2-2' }}</td>
                  <td class="text-right">{{ item.TOTAL / item.QUANTITY | number : '1.2-2' }}</td>
                  <td class="text-center">{{ item.QUANTITY }}</td>
                  <td class="text-right">{{ item.COST_PRICE }}</td>
                  <td class="text-right">{{ item.SALE_PRICE | number : '1.2-2' }}</td>
                  <td class="text-right">{{ item.VAT_CREDIT | number : '1.2-2' }}</td>
                  <td class="text-right">{{ item.SALE_PRICE - item.COST_PRICE | number : '1.2-2' }}</td>
                </tr>
              </ng-container>

              </tbody>
              <tfoot>
              <tr>
                <th class="text-left" colspan="3" style="border-right-color: #f3f8fd;">Margin
                  : {{ sale_price - cost_price | number : '1.2-2' }}
                </th>
                <th class="text-right" colspan="4">Grand Total</th>
                <th class="text-center">{{ sale_quantity }}</th>
                <th class="text-right">{{ cost_price | number : '1.2-2' }}</th>
                <th class="text-right">{{ sale_price | number : '1.2-2' }}</th>
                <th class="text-right">{{ vat_credit | number : '1.2-2' }}</th>
                <th class="text-right">{{ margin | number : '1.2-2' }}</th>
              </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #sales_return let-modal>
    <div class="modal-header">
      <div class="pull-right">
        <h5 class="modal-title" id="modal-basic-title">
          {{ medicine }}
        </h5>
      </div>
      <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="tab-pane active">
        <div class="tab-content">
          <div class="panel-body">
            <table class="table tbl table-hover table-bordered" style="background-color: #f3f8fd">
              <thead>
              <tr class="text-center">
                <th>Sl</th>
                <th>Invoice No</th>
                <th>Customer</th>
                <th>Invoice Date</th>
                <th>Quantity</th>
                <th>Return Quantity</th>
              </tr>
              </thead>
              <tbody>
              <ng-container *ngIf="sales_return_list.length > 0">
                <tr *ngFor="let item of sales_return_list;let i=index">
                  <td class="text-center">{{ 1 + i }}</td>
                  <td>{{ item.INVOICE_NUMBER }}</td>
                  <td>{{ item.CUSTOMER_NAME }}</td>
                  <td>{{ item.INVOICE_DATE }}</td>
                  <td class="text-center">{{ item.QUANTITY }}</td>
                  <td class="text-center">{{ item.RETURN_QUANTITY }}</td>
                </tr>
              </ng-container>
              <tr>
                <th colspan="6">Total Qunatity</th>
                <th class="text-center">{{ sale_return_quantity }}</th>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #saledetails let-modal>
    <div class="modal-header">
      <div class="pull-right">
        <h3 class="modal-title" id="modal-basic-title">
          Particular List
        </h3>
      </div>
      <div class="pull-right text-right">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </div>
      <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="tab-pane active">
        <div class="tab-content">
          <div class="panel panel-default">
            <div class="panel-heading"></div>
          </div>
          <div id="printInvoice">
            <div class="header-space">&nbsp;</div>
            <div class="header col-md-12">

              <div class="col-md-4 pull-left">
                <ng-container *ngIf="institution.INSTITUTION_LOGO">
                  <img alt="" height="150" ngSrc="{{logo_path+institution.INSTITUTION_LOGO}}" width="150">
                </ng-container>
              </div>
              <div class="col-md-8 pull-right text-right" style="padding-right: 0;">
                <ng-container *ngIf="institution">
                  <h5 class="name"><b>{{ institution.INSTITUTION_NAME }}</b></h5>
                  <div style="line-height: 0.5em;"><label>{{ institution.INSTITUTION_ADDRESS }}</label></div>
                  <div style="line-height: 0.5em;"><label>{{ institution.INSTITUTION_CITY }}
                    ,&nbsp;{{ institution.INSTITUTION_COUNTRY_NAME }}</label></div>
                  <div style="line-height: 0.5em;"><label>Ph :&nbsp;{{ institution.INSTITUTION_PHONE_NO }}</label></div>
                  <div style="line-height: 0.5em;"><label>Email :&nbsp;{{ institution.INSTITUTION_EMAIL }}</label></div>
                  <div style="line-height: 0.5em;"><label>VAT
                    IN&nbsp;&nbsp;:&nbsp;&nbsp;{{ institution.INSTITUTION_VAT_NO }},&nbsp;State Code&nbsp;&nbsp;:&nbsp;&nbsp;{{ institution.TIN_NUMBER }}</label>
                  </div>

                </ng-container>
              </div>
            </div>
            <div>&nbsp;</div>
            <div class="clearfix"></div>
            <h5 class="text-center">TAX INVOICE</h5>
            <br>
            <div>&nbsp;</div>
            <div *ngIf="saled" class="col-lg-12">
              <div class="col-8 pull-left " style="padding-left: 0;">
                <div *ngIf="saled.PATIENT_NAME" class="row">
                  <div class="col-10">
                    <label> Customer &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;</label><label> :
                    &nbsp;&nbsp;{{ saled.CUSTOMER_NAME }}</label><label
                    *ngIf="saled.CUSTOMER_ADDRESS">,&nbsp;{{ saled.CUSTOMER_ADDRESS }}</label><label
                    *ngIf="saled.CUSTOMER_PHONE">&nbsp;{{ saled.CUSTOMER_PHONE }}</label>
                  </div>
                </div>
                <div *ngIf="saled.PAYMENT_TYPE" class="row">
                  <div class="col-12">
                    <label>Payment Type&nbsp;&nbsp;</label>
                    <label class="text-left">
                      <ng-container *ngIf="saled.PAYMENT_TYPE == 1">:&nbsp;&nbsp; Cash</ng-container>
                      <ng-container *ngIf="saled.PAYMENT_TYPE == 0">:&nbsp;&nbsp; Card</ng-container>
                      <ng-container *ngIf="saled.PAYMENT_TYPE == 2">:&nbsp;&nbsp; Cheque</ng-container>
                      <ng-container *ngIf="saled.PAYMENT_TYPE == 3">:&nbsp;&nbsp; Bank</ng-container>
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-4 pull-right text-right" style="padding-right: 0;">

                <div *ngIf="saled.INVOICE_NUMBER"><label> Invoice No&nbsp;&nbsp; :&nbsp;
                  &nbsp;&nbsp;{{ saled.INVOICE_NUMBER }}</label></div>
                <div *ngIf="saled.SALE_DATE"><label> Invoice Date
                  &nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;{{ utils.date(saled.SALE_DATE) }}</label></div>
              </div>
              <div class="clearfix"></div>
              <div class="clearfix"></div>
              <div class="clearfix"></div>
              <table class=" container  col-md-12 printtable">
                <thead>
                <tr style="border-bottom: 1px solid #000;border-top: 1px solid #000;">

                  <th class="text-left" width="3%">#</th>
                  <th class="text-left">Item</th>
                  <th class="text-left" width="10%">HSN Code</th>
                  <th class="text-center" width="8%">MRP</th>
                  <th class="text-center" width="8%">Rate</th>
                  <th class="text-center" width="4%">Qty</th>
                  <th class="text-center" width="5%">UOM</th>
                  <th class="text-center" width="9%">Price</th>
                  <th class="text-center" width="6%">VAT %</th>
                  <th class="text-center" width="8%">VAT Amt</th>
                  <th class="text-center" width="8%">Flood Cess</th>
                  <th class="text-right" width="8%">Total</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let item of item_list;let i=index">
                  <td class="text-left">{{ i + 1 }}</td>
                  <td class="text-left"> {{ item.TRADE_NAME }}</td>
                  <td class="text-left">{{ item.HSN_CODE }}</td>
                  <td class="text-center">{{ item.MRP }}</td>
                  <td class="text-center">{{ item.UNIT_PRICE }}</td>
                  <td class="text-center">{{ item.QUANTITY }}</td>
                  <td class="text-center">{{ item.SHORT_FORM }}</td>
                  <td class="text-center">{{ item.PRICE }}</td>
                  <td class="text-center">{{ item.VAT }}</td>
                  <td class="text-center">{{ item.VAT_AMOUNT }}</td>
                  <td class="text-center">{{ item.FLOOD_CESS }}</td>
                  <td class="text-right">{{ item.TOTAL }}</td>
                </tr>
                <tr style="border-bottom: 1px solid #000;"></tr>
                </tbody>
              </table>
              <div class="clearfix">&nbsp;</div>
              <div class="clearfix">&nbsp;</div>
              <div class="clearfix">&nbsp;</div>
              <div class="clearfix">&nbsp;</div>
              <table>
                <th></th>
              </table>
              <div *ngIf="saled" class="  col-md-12" style="text-align:right;border-top: 1px solid #000;">
                Gross amount&nbsp;&nbsp;: &nbsp;&nbsp;{{ gross | number : '1.2-2' }}
                <ng-container *ngIf="saled && saled.DISCOUNT > 0">
                  <br>
                  Discount &nbsp;&nbsp;:&nbsp;&nbsp; {{ saled.DISCOUNT }}
                </ng-container>
                <ng-container *ngIf="saled && saled.FREIGHT_CHARGE > 0">
                  <br>
                  Frieght/Handling charge &nbsp;&nbsp;:&nbsp;&nbsp; {{ saled.FREIGHT_CHARGE }}
                </ng-container>
              </div>
              <div class=" col-md-12"
                   style="text-align:right;font-weight: bolder;font-size:18px;border-bottom-style:double;border-top-style:double;">
                Net bill amount : {{ price_total | number : '1.2-2' }}
              </div>
              <div class="clearfix"></div>

              <div class=" col-md-12">
                <span>Amount in words &nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;</span>
                <span style="text-transform:capitalize;">&nbsp;{{ numberToWords }} &nbsp;Rupees only </span>
                <div *ngIf="save_rate > 0" class="pull-right text-right">You saved Rs {{ save_rate }}/- &nbsp;&nbsp;
                </div>
              </div>

              <div class="  col-md-12 clearfix" style="border-bottom: 1px solid #000"></div>

              <div class="clearfix"></div>
              <div class="clearfix"></div>
              <div class="clearfix"></div>
              <div class="clearfix"></div>
              <table style="width: 100%;">
                <tr>
                  <td style="width: 70%;vertical-align: top;">
                    <table class="table table-bordered vat" style="width: 100%;">
                      <tr class="text-center">
                        <th width="3%">VAT %</th>
                        <th width="10%">Taxable value</th>
                        <ng-container *ngIf="saled.TIN_NUMBER  != 32">
                          <th class="text-center">VAT <br>
                            <span class="pull-left">&nbsp;&nbsp;&nbsp;%</span>
                            <span class="pull-right">Amount&nbsp;&nbsp;&nbsp;</span>
                          </th>
                        </ng-container>
                        <th class="text-center">Flood Cess <br>
                          <span class="pull-left">&nbsp;&nbsp;&nbsp;%</span>
                          <span class="pull-right">Amount&nbsp;&nbsp;&nbsp;</span>
                        </th>
                      </tr>
                      <tr *ngFor="let tax of vat_list">
                        <td class="text-center">{{ tax.VAT }}</td>
                        <td class="text-center">{{ (tax.TAXABLE_VALUE)| number : '1.2-2' }}</td>
                        <ng-container *ngIf="saled.TIN_NUMBER  !== 32">
                          <td width="6%">
                            <label class="pull-left">{{ tax.VAT }}</label>
                            <label class="pull-right">{{ (tax.VAT_VALUE)| number : '1.2-2' }}</label>
                          </td>
                        </ng-container>
                        <td width="6%">
                          <label class="pull-left">1.00</label>
                          <label class="pull-right">{{ (tax.FLOOD_CESS)| number : '1.2-2' }}</label>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td style="width: 30%;vertical-align: top;">
                    <table class="table table-bordered vat" style="width: 100%;">
                      <ng-container *ngIf="saled.TIN_NUMBER  !== 32">
                        <tr>
                          <th>VAT</th>
                          <th class="text-right"> {{ total_vat | number : '1.2-2' }}</th>
                        </tr>
                      </ng-container>
                      <tr>
                        <th>Flood Cess</th>
                        <th class="text-right"> {{ total_flood | number : '1.2-2' }}</th>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
              <div *ngIf="saled.SHIPPING_ADDRESS" class=" col-md-4 text-left"><br>
                <label style="font-weight: bold;">Shipping Address&nbsp;&nbsp;</label>
                <label [innerHTML]='saled.SHIPPING_ADDRESS | nl2br ' class="text-left"></label>
              </div>
              <div class="  col-md-12 clearfix" style="border-bottom: 1px solid #000"></div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #purchasedetails let-modal>
    <div class="modal-header">
      <div class="pull-right">
        <h5 class="modal-title" id="modal-basic-title">
          <ng-container *ngIf="purchased && purchased.VENDOR_NAME">{{ purchased.VENDOR_NAME }}</ng-container>
        </h5>
      </div>
      <div class="pull-right text-right">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </div>
      <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="tab-pane active">
        <div class="tab-content">
          <div class="panel-body">
            <table class="table tbl table-bordered table-hover">
              <thead>
              <tr class="text-center">
                <th>Sl</th>
                <th width="25%">Particular</th>
                <th width="5%">Purchased qty</th>
                <th width="5%">Freebie qty</th>
                <th>Total Qty</th>
                <th>UOM</th>
                <th>Unit Price</th>
                <th>Retail Price</th>
                <th>Amount</th>
                <th>VAT Amount</th>
                <th>Gross Amount</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let item of item_list;let i=index">
                <td class="text-center">{{ 1 + i }}</td>
                <td> {{ item.TRADE_NAME }}</td>
                <td>{{ item.PURCHASED_QUANTITY }}</td>
                <td>{{ item.FREEBIE_QUANTITY }}</td>
                <td>{{ item.QUANTITY }}</td>
                <td>{{ item.UNIT_DESC }}</td>
                <td class="text-right">{{ item.UNIT_PRICE }}</td>
                <td class="text-right">{{ item.MRP }}</td>
                <td class="text-right">{{ item.AMOUNT }}</td>
                <td class="text-right">{{ item.VAT_AMOUNT }}</td>
                <td class="text-right">{{ item.GROSS_AMOUNT }}</td>
              </tr>

              </tbody>
              <tfoot>
              <ng-container *ngIf="purchased && purchased.VENDOR_STATECODE == 32">
                <tr>
                  <td class="text-right" colspan="13">Gross Total</td>
                  <td class="text-right">{{ price_total |  number : '1.2-2' }}</td>
                </tr>
                <tr *ngIf="purchased">
                  <td class="text-right" colspan="13">Freight Charge</td>
                  <td class="text-right">{{ purchased.FREIGHT_CHARGE |  number : '1.2-2' }}</td>
                </tr>
                <tr *ngIf="purchased">
                  <td class="text-right" colspan="13">Discount</td>
                  <td class="text-right">{{ purchased.DISCOUNT |  number : '1.2-2' }}</td>
                </tr>
                <tr *ngIf="purchased">
                  <td class="text-right" colspan="13">Net Total</td>
                  <td class="text-right">{{ net_total |  number : '1.2-2' }}</td>
                </tr>
              </ng-container>
              <ng-container *ngIf="purchased && purchased.VENDOR_STATECODE  !== 32">
                <tr>
                  <td class="text-right" colspan="12">Gross Total</td>
                  <td class="text-right">{{ price_total |  number : '1.2-2' }}</td>
                </tr>
                <tr *ngIf="purchased">
                  <td class="text-right" colspan="12">Freight Charge</td>
                  <td class="text-right">{{ purchased.FREIGHT_CHARGE |  number : '1.2-2' }}</td>
                </tr>
                <tr *ngIf="purchased">
                  <td class="text-right" colspan="12">Discount</td>
                  <td class="text-right">{{ purchased.DISCOUNT |  number : '1.2-2' }}</td>
                </tr>
                <tr *ngIf="purchased">
                  <td class="text-right" colspan="12">Net Total</td>
                  <td class="text-right">{{ net_total |  number : '1.2-2' }}</td>
                </tr>
              </ng-container>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #damaged let-modal>
    <div class="modal-header">
      <div class="pull-right">
        <h5 class="modal-title" id="modal-basic-title">
          {{ medicine }}
        </h5>
      </div>
      <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="tab-pane active">
        <div class="tab-content">
          <div class="panel-body">
            <table class="table tbl table-hover table-bordered" style="background-color: #f3f8fd">
              <thead>
              <tr class="text-center">
                <th>Sl</th>
                <th width="10%">Invoice No</th>
                <th>Vendor</th>
                <th width="10%">Invoice Date</th>
                <th width="5%">Damaged Qty</th>
              </tr>
              </thead>
              <tbody>
              <ng-container *ngIf="damage_list.lenght>0">
                <tr *ngFor="let item of damage_list;let i=index">
                  <td class="text-center">{{ 1 + i }}</td>
                  <td>{{ item.INVOICE_NUMBER }}</td>
                  <td>{{ item.VENDOR_NAME }}</td>
                  <td>{{ item.INVOICE_DATE }}</td>
                  <td class="text-center">{{ item.DAMAGE_QUANTITY }}</td>
                </tr>
              </ng-container>
              <tr>
                <th colspan="5">Total Qunatity</th>
                <th class="text-center">{{ damage_quantity }}</th>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #warehuse let-modal>
    <div class="modal-header">
      <div class="pull-right">
        <h5 class="modal-title" id="modal-basic-title">
          {{ medicine }}
        </h5>
      </div>
      <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="tab-pane active">
        <div class="tab-content">
          <div class="panel-body">
            <table class="table tbl table-hover table-bordered" style="background-color: #f3f8fd">
              <thead>
              <tr class="text-center">
                <th>Sl</th>
                <th>Warehouse</th>
                <th>Quantity</th>
              </tr>
              </thead>
              <tbody>
              <ng-container *ngIf="warehouse_list.length > 0">
                <tr *ngFor="let item of warehouse_list;let i=index">
                  <td class="text-center">{{ 1 + i }}</td>
                  <td>{{ item.WAREHOUSE_NAME }}</td>
                  <td class="text-center">{{ item.WAREHOSE_AVAILABLE_QUANTITY }}</td>
                </tr>
              </ng-container>
              <tr>
                <th colspan="2">Total Quantity</th>
                <th class="text-center"><a (click)="modal.dismiss('link click')"
                                           routerLink="/purchase/warehouse-report/{{medicine_id}}">{{ warehouse_list_quantity }}</a>
                </th>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
